"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _SVGIcon = _interopRequireDefault(require("@instructure/ui-svg-images/lib/components/SVGIcon"));
var _ref = /*#__PURE__*/
_react.default.createElement("path", {
  d: "M860.16 1373.227L490.773 1003.84 641.6 853.013l218.56 218.56 453.653-453.653 150.827 150.827-604.48 604.48zM960 0C429.76 0 0 429.76 0 960s429.76 960 960 960c530.133 0 960-429.76 960-960S1490.133 0 960 0z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});
var IconPublish = /*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(IconPublish, _Component);
  function IconPublish() {
    (0, _classCallCheck2.default)(this, IconPublish);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(IconPublish).apply(this, arguments));
  }
  (0, _createClass2.default)(IconPublish, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(_SVGIcon.default, Object.assign({}, this.props, {
        name: "IconPublish",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);
  IconPublish.displayName = "IconPublish";
  return IconPublish;
}(_react.Component);
exports.default = IconPublish;
IconPublish.glyphName = 'publish';
IconPublish.variant = 'Solid';
IconPublish.propTypes = (0, _objectSpread2.default)({}, _SVGIcon.default.propTypes);